/* eslint-disable jsx-a11y/control-has-associated-label */
/*eslint-disable */
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Row,
  Col,
  Table,
  Form,
  InputGroup,
  Button,
  Alert,
  Spinner,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faCalendar } from '@fortawesome/pro-solid-svg-icons';
import { faBan, faImagePolaroid } from '@fortawesome/pro-regular-svg-icons';
import DatePicker from 'react-datepicker';
import { format, addBusinessDays } from 'date-fns';
import { useDraftPickList } from '../../hooks/pickList';
import { apiPost } from '../../../../api';

import 'react-datepicker/dist/react-datepicker.css';

function StorageInventoryReview() {
  const [requestDate, setRequestDate] = useState(null);
  const [PickTypeId, setPickTypeId] = useState(1);
  const [CustomerWillReceive, setCustomerWillReceive] = useState(true);
  const [invalidPick, setInvalidPick] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [submissionError, setSubmissionError] = useState(false);
  const { state: listState } = useLocation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const { handleRemoveFromPickList, handleNameChange, items, name } =
    useDraftPickList(listState?.name, listState?.items);

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    setSubmissionError(false);

    if (!PickTypeId) {
      setInvalidPick(true);
    } else {
      setInvalidPick(false);
    }
    const {
      FirstName,
      LastName,
      Address,
      Address2,
      City,
      State,
      Zip,
      CompanyName,
      Phone,
      Email,
      Notes,
    } = data;
    const itemIds = items.map((storageItem) => storageItem.InventoryItemID);
    const payload = {
      PickListName: name,
      RequestedDate: format(
        requestDate || addBusinessDays(new Date(), 2),
        'yyyy-MM-dd'
      ),
      PickTypeId,
      CustomerWillReceive,
      FirstName,
      LastName,
      Address,
      Address2,
      City,
      State,
      Zip,
      CompanyName,
      Phone,
      Email,
      Notes,
      Items: itemIds,
    };
    try{
      const response = await apiPost('storage/inventory/picklists', payload);
      if (response.ok) {
        const { success } = await response.json();
        if (!success) {
          setSubmissionError(true);
          setIsSubmitting(false);
          return;
        }
        setIsSubmitting(false);
        navigate('/portal/storage/inventory', { state: { success: true } });
      }
    }catch(e){
      setSubmissionError(true)
    }


    setIsSubmitting(false);
  };

  const pickupFromWarehouse = PickTypeId === 2;

  const datePickerStartDate = addBusinessDays(new Date(), 2);

  return (
    <div className="portal-inner has-tabs">
      <Link
        to="/portal/storage/inventory"
        className="back-link"
        state={{ name, items }}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
        Return to Inventory
      </Link>
      <Row>
        <Col xl={9}>
          <div className="info-box">
            <div className="info-header">
              <h3>Review and Request</h3>
            </div>
            <div className="info-content">
              <Form.Group className="mb-4 w-50">
                <Form.Label>List Name</Form.Label>
                <Form.Control
                  type="text"
                  id="list-name"
                  value={name}
                  onChange={(e) => {
                    handleNameChange(e.target.value);
                  }}
                />
              </Form.Group>
              <Table className="table-borderless mb-5" responsive>
                <thead>
                  <tr>
                    <th width="4%" />
                    <th>Item No.</th>
                    <th>Item Name</th>
                    <th>Ship No.</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <tr key={item.InventoryItemID}>
                      <td>
                        <FontAwesomeIcon
                          icon={faImagePolaroid}
                          size="lg"
                          className="text-primary"
                        />
                      </td>
                      <td>{item.ItemTag}</td>
                      <td>{item.ItemName}</td>
                      <td>{item.ShipmentNumber}</td>
                      <td className="actions text-end">
                        <a
                          href="#"
                          className="btn btn-link"
                          onClick={(e) => {
                            e.preventDefault();
                            handleRemoveFromPickList(item);
                          }}
                        >
                          <FontAwesomeIcon icon={faBan} size="lg" />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Form>
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mb-5">
                      <Form.Label className="mb-3">
                        How would you like to receive your items?
                      </Form.Label>
                      <Form.Check
                        type="radio"
                        id="deliver"
                        name="delivery-type"
                        label="Deliver to address"
                        className="mb-4"
                        checked={PickTypeId === 1}
                        onChange={() => setPickTypeId(1)}
                        isInvalid={invalidPick}
                      />
                      <Form.Check
                        type="radio"
                        id="pick-up"
                        name="delivery-type"
                        label="Pick up at warehouse"
                        checked={PickTypeId === 2}
                        onChange={() => setPickTypeId(2)}
                        isInvalid={invalidPick}
                      />
                    </Form.Group>
                    <Form.Group as={Row} className="datepicker mb-3">
                      <Col sm={6}>
                        <Form.Label>Request Delivery Date</Form.Label>
                        <InputGroup>
                          <DatePicker
                            selected={requestDate}
                            open={isDatePickerOpen}
                            startDate={datePickerStartDate}
                            minDate={datePickerStartDate}
                            onChange={(date) => setRequestDate(date)}
                            onCalendarClose={() => setIsDatePickerOpen(false)}
                            onCalendarOpen={() => setIsDatePickerOpen(true)}
                            className="form-control"
                          />
                          <InputGroup.Text>
                            <FontAwesomeIcon
                              icon={faCalendar}
                              size="lg"
                              onClick={() =>
                                setIsDatePickerOpen(!isDatePickerOpen)
                              }
                            />
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                      <Col sm={12}>
                        <Form.Text>
                          The earliest possible service is 2 business days. A Moving Consultant will be in touch to confirm the availability of your requested date.
                        </Form.Text>
                      </Col>
                    </Form.Group>
                    <Form.Group className="mb-5">
                      <Form.Label className="mb-3">
                        Are you receiving these items yourself?
                      </Form.Label>
                      <Form.Check
                        type="radio"
                        id="yes"
                        name="pickup-person"
                        label="Yes"
                        className="mb-4"
                        onChange={() => setCustomerWillReceive(true)}
                        checked={CustomerWillReceive}
                      />
                      <Form.Check
                        type="radio"
                        id="no"
                        name="pickup-person"
                        label="No, someone else will (3rd party)"
                        onChange={() => setCustomerWillReceive(false)}
                        checked={!CustomerWillReceive}
                      />
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={6}>
                        <Form.Label>Receiver's First Name</Form.Label>
                        <Form.Control
                          type="text"
                          id="receiver-first-name"
                          isInvalid={errors.FirstName}
                          {...register('FirstName', { required: true })}
                        />
                      </Col>
                      <Col sm={6}>
                        <Form.Label>Receiver's Last Name</Form.Label>
                        <Form.Control
                          type="text"
                          id="receiver-last-name"
                          isInvalid={errors.LastName}
                          {...register('LastName', { required: true })}
                        />
                      </Col>
                    </Form.Group>
                    {!pickupFromWarehouse && (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label>Street Address 1</Form.Label>
                          <Form.Control
                            type="text"
                            id="street-address-1"
                            isInvalid={errors.Address}
                            {...register('Address', { required: true })}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Street Address 2</Form.Label>
                          <Form.Control
                            type="text"
                            id="street-address-2"
                            {...register('Address2')}
                          />
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                          <Col sm={6}>
                            <Form.Label>City</Form.Label>
                            <Form.Control
                              type="text"
                              id="city"
                              isInvalid={errors.City}
                              {...register('City', { required: true })}
                            />
                          </Col>
                          <Col sm={6}>
                            <Form.Group as={Row}>
                              <Col sm={6}>
                                <Form.Label>State</Form.Label>
                                <Form.Select
                                  id="state"
                                  isInvalid={errors.State}
                                  {...register('State', { required: true })}
                                >
                                  <option value="AL">AL</option>
                                  <option value="AK">AK</option>
                                  <option value="AR">AR</option>
                                  <option value="AZ">AZ</option>
                                  <option value="CA">CA</option>
                                  <option value="CO">CO</option>
                                  <option value="CT">CT</option>
                                  <option value="DC">DC</option>
                                  <option value="DE">DE</option>
                                  <option value="FL">FL</option>
                                  <option value="GA">GA</option>
                                  <option value="HI">HI</option>
                                  <option value="IA">IA</option>
                                  <option value="ID">ID</option>
                                  <option value="IL">IL</option>
                                  <option value="IN">IN</option>
                                  <option value="KS">KS</option>
                                  <option value="KY">KY</option>
                                  <option value="LA">LA</option>
                                  <option value="MA">MA</option>
                                  <option value="MD">MD</option>
                                  <option value="ME">ME</option>
                                  <option value="MI">MI</option>
                                  <option value="MN">MN</option>
                                  <option value="MO">MO</option>
                                  <option value="MS">MS</option>
                                  <option value="MT">MT</option>
                                  <option value="NC">NC</option>
                                  <option value="NE">NE</option>
                                  <option value="NH">NH</option>
                                  <option value="NJ">NJ</option>
                                  <option value="NM">NM</option>
                                  <option value="NV">NV</option>
                                  <option value="NY">NY</option>
                                  <option value="ND">ND</option>
                                  <option value="OH">OH</option>
                                  <option value="OK">OK</option>
                                  <option value="OR">OR</option>
                                  <option value="PA">PA</option>
                                  <option value="RI">RI</option>
                                  <option value="SC">SC</option>
                                  <option value="SD">SD</option>
                                  <option value="TN">TN</option>
                                  <option value="TX">TX</option>
                                  <option value="UT">UT</option>
                                  <option value="VT">VT</option>
                                  <option value="VA">VA</option>
                                  <option value="WA">WA</option>
                                  <option value="WI">WI</option>
                                  <option value="WV">WV</option>
                                  <option value="WY">WY</option>
                                </Form.Select>
                              </Col>
                              <Col sm={6}>
                                <Form.Label>Zip</Form.Label>
                                <Form.Control
                                  type="text"
                                  id="zip"
                                  isInvalid={errors.Zip}
                                  {...register('Zip', { required: true })}
                                />
                              </Col>
                            </Form.Group>
                          </Col>
                        </Form.Group>
                      </>
                    )}
                    <Form.Group className="mb-3">
                      <Form.Label>Company Name</Form.Label>
                      <Form.Control
                        type="text"
                        id="company"
                        {...register('CompanyName')}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Contact's Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        id="phone"
                        isInvalid={errors.Phone}
                        {...register('Phone', { required: true })}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Contact's Email</Form.Label>
                      <Form.Control
                        type="text"
                        id="email"
                        isInvalid={errors.Email}
                        {...register('Email', { required: true })}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Text>
                  By submitting this form, you are authorizing this person to
                  remove all of the items indiciated in the list above.
                </Form.Text>
                <hr />
                <Form.Group className="mb-3">
                  <Form.Label>Notes</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Add notes about request here"
                    {...register('Notes')}
                  />
                </Form.Group>
                {submissionError && (
                  <Alert 
                  transition={false}
                  show>
                    There was an issue submitting your request. Please try
                    again.
                  </Alert>
                )}

                <Form.Group>
                  <Button
                    disabled={isSubmitting}
                    variant="primary"
                    onClick={handleSubmit(onSubmit)}
                  >
                    {' '}
                    {isSubmitting && <Spinner animation="border" />}
                    Submit Request
                  </Button>
                  <Link to="/portal/storage" className="btn btn-link">
                    Cancel
                  </Link>
                </Form.Group>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default StorageInventoryReview;
